import { HttpApiEndpoint, HttpApiError, HttpApiGroup } from "@effect/platform";
import { Schema } from "effect";
import { DatabaseError, DataIntegrityError } from "../auth/errors";
import { Authorization } from "../auth/middleware";
import { AccountId, ShopperAiIntegrationId } from "../ids/definitions";
import {
  IntegrationCursor,
  IntegrationWithChannelDataResponse,
} from "../models/shopper-ai/integration/integration";
import {
  CursorPaginatedResponse,
  CursorPaginationParams,
} from "../schema/pagination";

export const IntegrationGroup = HttpApiGroup.make("integration")
  .add(
    HttpApiEndpoint.get("getIntegration", "/integrations/:id")
      .middleware(Authorization)
      .setPath(Schema.Struct({ id: ShopperAiIntegrationId }))
      .addSuccess(IntegrationWithChannelDataResponse)
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    HttpApiEndpoint.get(
      "getIntegrationsByAccount",
      "/accounts/:accountId/integrations",
    )
      .middleware(Authorization)
      .setPath(Schema.Struct({ accountId: AccountId }))
      .setUrlParams(CursorPaginationParams(IntegrationCursor))
      .addSuccess(
        CursorPaginatedResponse(
          IntegrationWithChannelDataResponse,
          IntegrationCursor,
        ),
      )
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
